/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Billing_SaveInputs */

const en_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save 20%`)
};

const es_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra 20%`)
};

const fr_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Économisez 20 %`)
};

const de_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% sparen`)
};

const ja_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20%割引`)
};

const zh_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`节省 20%`)
};

const ar_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وفر 20%`)
};

const id_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemat 20%`)
};

const it_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risparmia il 20%`)
};

const ru_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скидка 20%`)
};

const pt_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economize 20%`)
};

const ko_pricing_billing_save = /** @type {(inputs: Pricing_Billing_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`20% 절약`)
};

/**
* | output |
* | --- |
* | "Save 20%" |
*
* @param {Pricing_Billing_SaveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_billing_save = /** @type {((inputs?: Pricing_Billing_SaveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Billing_SaveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_billing_save(inputs)
	if (locale === "es") return es_pricing_billing_save(inputs)
	if (locale === "fr") return fr_pricing_billing_save(inputs)
	if (locale === "de") return de_pricing_billing_save(inputs)
	if (locale === "ja") return ja_pricing_billing_save(inputs)
	if (locale === "zh") return zh_pricing_billing_save(inputs)
	if (locale === "ar") return ar_pricing_billing_save(inputs)
	if (locale === "id") return id_pricing_billing_save(inputs)
	if (locale === "it") return it_pricing_billing_save(inputs)
	if (locale === "ru") return ru_pricing_billing_save(inputs)
	if (locale === "pt") return pt_pricing_billing_save(inputs)
	return ko_pricing_billing_save(inputs)
});